import { AppButtonModule } from 'src/app/components/button/button.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AttachmentsListComponent } from "./attachments-list.component";
import { ContentTypeToRiIconPipeModule } from "src/app/pipes/content-type-to-ri-icon/content-type-to-ri-icon.pipe.module";
import { FileLoaderComponent } from "../file-loader/file-loader.component";


@NgModule({
  declarations: [
    AttachmentsListComponent
  ],
  imports: [
    AppButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ContentTypeToRiIconPipeModule,
    FileLoaderComponent,
  ],
  exports: [

    AttachmentsListComponent,
    ContentTypeToRiIconPipeModule
  ]
})

export class AttachmentsListComponentModule { }
